import React, { useState, useEffect } from "react"
import { connect } from 'react-redux'
import { Row, Col, Tree, Tag, Table, Space, message, Modal, Form, Select, Input, Cascader } from 'antd'
const { Option } = Select
import RoleApi from '@/api/role'
import DepartmentApi from '@api/department'
import SystemManagement from '@/api/SystemManagement'
import { getStationData } from '@utils/common'
import './index.scss'

const layout = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 16,
  },
}
const DepartMentPerson = (props) => {
  const [form] = Form.useForm()
  const [roleForm] = Form.useForm()
  const [userForm] = Form.useForm()
  const [departmentList, setDepartmentList] = useState([])
  const [selectedNode, setSelectedNode] = useState([])
  const [selectedKey, setSelectedKey] = useState([])
  const [loading, setLoading] = useState(false)
  const [personList, setPersonList] = useState([])
  const [total, setTotal] = useState(0)
  const [deptId, setDeptId] = useState(0)
  const [sourceStationVisi, setSourceStationVisi] = useState(false)
  const [stationData, setStationData] = useState([])
  const [sourceId, setSourceId] = useState()
  const [roleData, setRoleData] = useState([])
  const [sourceRoleVisi, setSourceRoleVisi] = useState(false)
  const [sourceRoleId, setSourceRoleId] = useState()
  const [userFormModal, setUserFormModal] = useState(false)
  const [userId, setUserId] = useState()
  const [deptList, setDeptList] = useState()
  const [oldName, setOldName] = useState()
  const [businessParamsFlag, setBusinessParamsFlag] = useState(false)
  const [businessList, setBusinessList] = useState([])
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10
  })

  useEffect(() => {
    getStationList()
    return () => { }
  }, [])

  useEffect(() => {
    getDepartment()
    getRolesList()
  }, [])

  useEffect(() => {
    getUserList()
  }, [searchParams])

  const getDepartment = () => {
    DepartmentApi.getDeptForTree({}).then(res => {
      if (res.status == 0) {
        const handleData = getTreeData(res.data)
        setDeptList(handleData)
        setDepartmentList([{
          title: '主部门',
          value: '0',
          key: '0',
          children: handleData
        }])
      }
    })
  }

  const getRolesList = () => {
    RoleApi.query({
      pageNum: 1,
      pageSize: 999,
    }).then(res => {
      if (res.status == 0 && res.data) {
        setRoleData(res.data.data)
      }
    })
  }

  // 获取厂站列表
  const getStationList = () => {
    let data = getStationData(props.userInfo.stationIds ? props.userInfo.stationIds : '-1', props.userInfo.stationAliasName)
    // data.splice(0, 1)
    setStationData(data)
  }

  // 递归处理数据
  const getTreeData = (data) => {
    for (var i = 0; i < data.length; i++) {
      if (data[i].children.length < 1) {
        data[i].title = data[i].name
        data[i].key = data[i].id
      } else {
        data[i].title = data[i].name
        data[i].key = data[i].id
        getTreeData(data[i].children)
      }
    }
    return data
  }

  const onSelect = (selectedKeys, info) => {
    setSelectedKey(selectedKeys)
    setSelectedNode(info.node)
    setDeptId(selectedKeys[0] - 0)
    let params = {
      pageNum: 1,
      pageSize: 10
    }
    setSearchParams(params)
  }

  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  }

  const getUserList = () => {
    setLoading(true)
    DepartmentApi.pageListAll({ ...searchParams, deptId }).then(res => {
      if (res.status === '0') {
        setLoading(false)
        setPersonList(res.data?.data)
        setTotal(res.data?.total)
      }
    })
  }

  // 打开关联厂站
  const openSourceStation = (record) => {
    const { id, stationIds } = record
    if (stationIds) {
      form.setFieldsValue({ 'stationIds': stationIds.split(',') })
    }
    setSourceStationVisi(true)
    setSourceId(id)
  }

  // 打开关联角色
  const openSourceRole = (record) => {
    const { id, roleIds } = record
    if (roleIds) {
      roleForm.setFieldsValue({ roleIds })
    }
    setSourceRoleVisi(true)
    setSourceRoleId(id)
  }

  // 打开编辑弹窗
  const openEdit = (record) => {
    setOldName(record.name)
    const params = JSON.parse(JSON.stringify(record))
    params.deptId = findAllParents(deptList, params.deptId)
    params.stationIds = params.stationIds ? params.stationIds.split(',') : []
    params.roleIds = params.roleIds ? params.roleIds.split(',') : []
    const cDept = findItem(deptList, record.deptId)
    if (cDept.length > 0 && cDept[0].name == '公司经营层') {
      setBusinessParamsFlag(true)
      params.manageDeptList = record.manageDeptList ? record.manageDeptList.split(',') : []
      getlistBusinessDepts(record.deptId, params.manageDeptList)
    } else {
      setBusinessParamsFlag(false)
    }
    setUserFormModal(true)
    setUserId(record.id)
    userForm.setFieldsValue(params)
  }

  // 更新钉钉用户
  const updateDDid = (id) => {
    DepartmentApi.updateDingUserId({ id }).then(res => {
      if (res.status === '0') {
        message.success('更新成功')
      }
    })
  }

  // 查找所有父元素
  const findAllParents = (map, id) => {
    let t = []
    for (let i = 0; i < map.length; i++) {
      const e = map[i]
      if (e.id === id) {
        //若查询到对应的节点，则直接返回
        t.push(e.id)
        break
      } else if (e.children && e.children.length !== 0) {
        //判断是否还有子节点，若有对子节点进行循环调用
        let p = findAllParents(e.children, id)
        //若p的长度不为0，则说明子节点在该节点的children内，记录此节点，并终止循环
        if (p.length !== 0) {
          p.unshift(e.id)
          t = p
          break
        }
      }
    }
    return t
  }


  // 提交信息修改
  const submitUserFormModal = () => {
    userForm.validateFields().then(values => {
      if (!values) return
      const stations = []
      values.stationIds.forEach(item => {
        stationData.forEach(subItem => {
          if (item == subItem.value) {
            stations.push(subItem.title)
          }
        })
      })
      const params = {
        stationIds: values.stationIds.join(','),
        stations: stations.join(','),
        id: userId,
        realName: values.realName,
        oldName,
        name: values.name,
        phone: values.phone,
        deptId: values.deptId[values.deptId.length - 1],
        roleIds: values.roleIds.join(','),
        roleLevel: values.roleLevel
      }
      if (values.manageDeptList) {
        params.manageDeptList = values.manageDeptList.join(',')
      }
      SystemManagement.updateUser({ ...params }).then(res => {
        if (res.status === '0') {
          message.success('修改成功')
          closeUserFormModal()
          getUserList()
        }
      })
    })
  }

  // 关联厂站
  const submitSourceStation = () => {
    form.validateFields().then(values => {
      if (!values) return
      const stations = []
      values.stationIds.forEach(item => {
        stationData.forEach(subItem => {
          if (item == subItem.value) {
            stations.push(subItem.title)
          }
        })
      })
      const params = {
        stationIds: values.stationIds.join(','),
        stations: stations.join(','),
        id: sourceId
      }
      SystemManagement.updateUser(params).then(res => {
        if (res.status === '0') {
          message.success('关联成功')
          closeSourceStation()
          getUserList()
        }
      })
    })
  }

  const submitSourceRole = () => {
    roleForm.validateFields().then(values => {
      if (!values) return
      SystemManagement.updateUser({ id: sourceRoleId, ...values }).then(res => {
        if (res.status === '0') {
          message.success('关联成功')
          closeSourceRole()
          getUserList()
        }
      })
    })
  }

  const closeSourceStation = () => {
    form.resetFields()
    setSourceStationVisi(false)
    setSourceId(null)
  }

  const closeSourceRole = () => {
    roleForm.resetFields()
    setSourceRoleVisi(false)
    setSourceRoleId(null)
  }

  // 关闭用户修改信息
  const closeUserFormModal = () => {
    userForm.resetFields()
    setUserFormModal(false)
    setUserId(null)
  }

  // 切换部门
  const changeDept = (e) => {
    const id = e[e.length - 1]
    const cDept = findItem(deptList, id)
    if (cDept[0].name == '公司经营层') {
      userForm.setFieldsValue({ manageDeptList: [] })
      setBusinessParamsFlag(true)
      getlistBusinessDepts(id)
    } else {
      setBusinessParamsFlag(false)
    }
  }

  const getlistBusinessDepts = (id, list) => {
    SystemManagement.listBusinessDepts({ id }).then(res => {
      if (res.status === '0') {
        if ( list && list.length > 0 ) {
          list.forEach(item => {
            res.data.map(subItem => {
              if ( subItem.id === item ) {
                subItem.isChoosed = true
              }
            })
          })
          setBusinessList(res.data)
        } else {
          setBusinessList(res.data)
        }
      }
    })
  }

  // 递归查询当前部门数据
  const findItem = (params, id, arr = []) => {
    params.forEach(item => {
      if (item.id == id) {
        arr.push(item)
      } else {
        findItem(item.children, id, arr)
      }
    })
    return arr
  }

  const columns = [
    {
      title: '姓名',
      dataIndex: 'realName',
      align: 'center',
      key: 'realName',
    },
    {
      title: '厂站',
      dataIndex: 'stations',
      align: 'center',
      key: 'stations'
    },
    {
      title: '角色',
      dataIndex: 'roleNames',
      align: 'center',
      key: 'roleNames'
    },
    {
      title: '操作',
      key: 'operation',
      fixed: 'right',
      width: 300,
      render: record => {
        return (
          <Space size="middle">
            {/* <Tag onClick={() => openSourceStation(record)} color="#2db7f5">关联厂站</Tag>
            <Tag onClick={() => openSourceRole(record)} color="#2db7f5">关联角色</Tag> */}
            <Tag onClick={() => openEdit(record)} color="#2db7f5">编辑</Tag>
            <Tag onClick={() => updateDDid(record.id)} color="#2db7f5">更新钉钉用户</Tag>
          </Space>
        )
      }
    }
  ]

  return (
    <div className="department-person">
      <div className="department-person-wrap">
        <Row gutter={50}>
          <Col span={8} style={{ borderRight: '1px solid #dfdfdf' }}>
            {
              departmentList.length > 0 &&
              <Tree
                defaultExpandAll={true}
                defaultSelectedKeys={['0']}
                showLine={true}
                onSelect={onSelect}
                treeData={departmentList}
              />
            }
          </Col>
          <Col span={16}>
            <Table
              className='Table'
              scroll={{ x: columns.length * 200 }}
              columns={columns}
              dataSource={personList}
              rowKey={record => record.id}
              pagination={{
                current: searchParams.pageNum,
                pageSize: searchParams.pageSize,
                showQuickJumper: true,
                showSizeChanger: true,
                showTotal: total => `共${total}条数据`,
                total: total
              }}
              onChange={handleTableChange}
              loading={loading}
            />
          </Col>
        </Row>
      </div>
      <Modal
        title="关联厂站"
        open={sourceStationVisi}
        onCancel={closeSourceStation}
        onOk={submitSourceStation}
        width={600}
      >
        <Form preserve={false}
          {...layout}
          name="basic"
          form={form}
          style={{ marginTop: '20px' }}
        >
          <Form.Item
            name="stationIds"
            label="厂站管理"
            rules={[{ required: true, message: '请选择厂站!' }]}
          >
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="请选择厂站"
            >
              {stationData.length > 0 && stationData.map(item => <Option value={item.value + ''} key={item.value}>{item.title}</Option>)}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
      {/* 关联角色 */}
      <Modal
        title="关联角色"
        open={sourceRoleVisi}
        onCancel={closeSourceRole}
        onOk={submitSourceRole}
      >
        <Form preserve={false}
          {...layout}
          name="basic"
          form={roleForm}
          style={{ marginTop: '20px' }}
        >
          <Form.Item
            name="roleIds"
            label="角色级别"
            rules={[{ required: true, message: '请选择角色级别!' }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="请选择角色级别"
              mode="multiple"
            >
              {roleData.length > 0 && roleData.map(item => <Option value={item.id + ''} key={item.id}>{item.name}</Option>)}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
      {/* 修改用户 */}
      <Modal
        title="修改用户"
        open={userFormModal}
        onCancel={closeUserFormModal}
        onOk={submitUserFormModal}
      >
        <Form preserve={false}
          {...layout}
          name="basic"
          form={userForm}
          style={{ marginTop: '20px' }}
        >
          <Form.Item
            label='人员姓名'
            name="realName"
            rules={[{ required: true, message: '请输入名字!' }]}
          >
            <Input placeholder={'请输入名字'} />
          </Form.Item>
          <Form.Item
            label='账号'
            name="name"
            rules={[{
              required: true,
              pattern: new RegExp(/^\w+$/),
              message: '请输入正确的账号'
            }]}
          >
            <Input placeholder={'请输入账号'} />
          </Form.Item>
          <Form.Item
            label='手机号'
            name="phone"
            rules={[{
              required: true,
              pattern: new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/),
              message: '请输入正确的手机号'
            }]}
          >
            <Input placeholder={'请输入手机号'} />
          </Form.Item>
          <Form.Item name="roleLevel" label="权限级别"
            rules={[{ required: true, message: '请选择权限级别!' }]}
          >
            <Select
              placeholder="请选择权限级别"
              allowClear
            >
              <Select.Option value={1}>管理员</Select.Option>
              <Select.Option value={2}>技术人员</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="deptId" label="部门"
            rules={[{ required: true, message: '请选择部门!' }]}
          >
            <Cascader
              fieldNames={{
                label: 'title',
                value: 'key',
                children: 'children',
              }}
              options={deptList}
              placeholder="请选择部门"
              onChange={changeDept}
            />
          </Form.Item>

          {
            businessParamsFlag &&
            <Form.Item name="manageDeptList" label="经营层所管理部门"
              rules={[{ required: true, message: '请选择经营层所管理部门!' }]}
            >
              <Select
                mode='multiple'
                placeholder="请选择经营层所管理部门"
                allowClear
              >
                {
                  businessList && businessList.map((v, i) => {
                    return (
                      <Select.Option key={v.id} value={v.id} disabled={v.isChoosed ? false : true}>{v.name}</Select.Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
          }

          <Form.Item
            name="roleIds"
            label="角色级别"
            rules={[{ required: true, message: '请选择角色级别!' }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="请选择角色级别"
              mode="multiple"
            >
              {roleData.length > 0 && roleData.map(item => <Option value={item.id + ''} key={item.id}>{item.name}</Option>)}
            </Select>
          </Form.Item>
          <Form.Item
            name="stationIds"
            label="厂站管理"
            rules={[{ required: true, message: '请选择厂站!' }]}
          >
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="请选择厂站"
            >
              {stationData.length > 0 && stationData.map(item => <Option value={item.value + ''} key={item.value}>{item.title}</Option>)}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
}

export default connect(mapStateToProps)(DepartMentPerson)